import {
  AfterViewInit,
  Component,
  ElementRef,
  Injectable,
  OnDestroy,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  BehaviorSubject,
  catchError,
  combineLatest,
  EMPTY,
  filter,
  from,
  map,
  Observable,
  of,
  Subject,
  switchMap,
  take,
  takeUntil,
  tap,
} from 'rxjs';
import { DataRequestState } from 'src/app/data-request/model';
import { toRequestState } from 'src/app/data-request/operators';
import { ThreeHandlerMode } from 'src/app/models_new/classes/3dview/three-handler-mode';
import { Project } from 'src/app/models_new/classes/project';
import { DialogSize } from 'src/app/models_new/enums/dialogSize';
import {
  ISimulationCollision,
  ISimulationDetails,
  ISimulationMovementBox,
} from 'src/app/models_new/types/simulation-details';
import { CameraType } from 'src/app/services/3dview/input-handler.service';
import {
  IArtifactsUrl,
  ISimulationShare,
  SimulationApiService,
} from 'src/app/services/api/simulation-api.service';
import { DialogService } from 'src/app/services/dialog.service';
import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { ExportImportService } from 'src/app/services/export-import.service';
import { NotificationService } from 'src/app/services/notification.service';
import { ITableData } from '../../gui/table/table.component';
import { Clipboard } from '@angular/cdk/clipboard';
import { pagesPATH } from 'src/app/models_new/config/pages';
import { IBreadcrumb } from 'src/app/models_new/types/breadcrumb';
import {
  SimulationStatus,
  simulationStatuses,
} from 'src/app/models_new/enums/simulation-status';
import { IPallyFileType } from 'src/app/models_new/types/pally-file-type';
import { InfoPopupComponent } from '../../dialogs/info-popup/info-popup.component';
import {
  InfoApiService,
  ISimulationFooterElement,
} from 'src/app/services/api/info-api.service';
import { StateService } from 'src/app/auth/state.service';
import { RenameSimulationComponent } from '../../dialogs/rename-simulation/rename-simulation.component';
import { MatDialog } from '@angular/material/dialog';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics-service.service';
import { UrlUtils } from 'src/app/utils/url';
import { QuoteFormDialogComponent } from '../../dialogs/quote-form-dialog/quote-form-dialog.component';
import { PdfPreviewComponent } from '../../dialogs/pdf-preview/pdf-preview.component';
import { AppLayoutService } from 'src/app/services/app-layout.service';
import { jsPDF } from 'jspdf';
import { calcTotalPalletLoadHeightFromPallyFile } from '../../../utils/div';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { getConvertedValue } from '../../../utils/unit-utils';
import * as UnitUtils from '../../../utils/unit-utils';
import { SimulationType } from '../../../services/api/comment-api.service';
import { PlayerMode } from '../../gui/rosbag-player/rosbag-player.component';
import { ListOfAllPallets } from 'src/app/models_new/config/form_fields';
import { Location } from '@angular/common';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { LocalStorageKey } from 'src/app/models_new/enums/local-storage-keys';
import { UnitSystemPipe } from 'src/app/pipes/unit-system.pipe';
import * as pdfUtils from '../../../utils/pdf-utils';
import { PalletReportComponent } from '../../patterns/pattern/pattern-report/pallet-report.component';
import { PublicApiService } from 'src/app/services/api/public-api.service';
import { ISimvizLoadInfo } from 'src/app/models_new/types/simviz-load-info';
import { IInfoCard } from 'src/app/models_new/types/info-card-config';
import { SimvizComponent } from '../simviz/simviz.component';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import { MarketingTagID } from 'src/app/models_new/config/marketing-tags';

type tableName =
  | 'hw'
  | 'sw'
  | 'installation'
  | 'pally'
  | 'status'
  | 'productivity'
  | 'safety_settings'
  | 'power'
  | 't_w';

@Component({
  selector: 'app-simulation-details',
  templateUrl: './simulation-details.component.html',
  styleUrls: ['./simulation-details.component.scss'],
})
export class SimulationDetailsComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  orderOriginal = (): number => {
    return 0;
  };

  history = history;
  destroy$ = new Subject<undefined>();
  simulationDetails$: Observable<DataRequestState<ISimulationDetails>>;
  simulationDetailsData$: Observable<ISimulationDetails>;
  project: Project;
  second_project: Project;
  palletScreenShot: string;
  ThreeHandlerMode = ThreeHandlerMode;
  Perspective = CameraType;
  SimulationStatus = SimulationStatus;
  simulationStatuses = simulationStatuses;
  loading = false;
  isPublic$: Observable<boolean>;
  isOpen: boolean;
  isThirdPartySimulation: boolean;
  publicCustomerOrganizationAsset: string;
  publicSalesOrganizationAsset: string;
  simReportDisabled: boolean;
  isFirstLoad = true;

  publicSimulationShare$: Observable<ISimulationShare[]>;
  simSharedValidTo: string;
  breadcrumbs: IBreadcrumb[] = [];
  lastActionTimestamp: number;
  useImperial: boolean = false;
  contentfulSimFooterElements$: Observable<
    DataRequestState<ISimulationFooterElement[]>
  >;
  isQueued: boolean = true;
  pagesPATH = pagesPATH;

  patternReportData: IPallyFileType;
  showReport: boolean = false;
  @ViewChild('palletReport') palletReport: PalletReportComponent;
  @ViewChild('palletReport', { read: ElementRef }) palletReportRef: ElementRef;

  @ViewChildren('spinner') spinner: QueryList<any>;
  @ViewChild('simulationReport', { static: false })
  simulationReport: ElementRef<HTMLElement>;

  @ViewChild(SimvizComponent) simviz: SimvizComponent;

  tabSelectedIndex: number;

  artifactsURL: IArtifactsUrl;
  CommentAccessMode = SimulationType;

  simulationPlayerMode: PlayerMode = PlayerMode.DEFAULT;
  docElement: HTMLElement;
  playerMode = PlayerMode;

  isDownloadsMenuOpen = false;

  #_infoPopupDataSource: Observable<IInfoCard[]>;
  get infoPopupDataSource() {
    if (this.#_infoPopupDataSource) {
      return this.#_infoPopupDataSource;
    } else {
      const infoPopupDataSource = this.infoApi.getSimulationDetailsInfoCards();
      this.#_infoPopupDataSource = infoPopupDataSource;
      return infoPopupDataSource;
    }
  }
  movementBoxes: { [key: string]: ISimulationMovementBox } = {};

  displayedColumns = {
    hw: ['hardware used', 'product identifier'],
    installation: ['installation setup', 'values'],
    sw: ['software used', 'product identifier'],
    pally: ['PALLY settings', 'values'],
    status: [
      'Completed Status',
      'CPM Required',
      'CPM Achieved',
      'Avg time per pallet',
      'Number of Collisions',
      'Smart grip',
    ],
    productivity: ['Productivity', 'Per Day', 'Per Month*', 'Per Year*'],
    safety_settings: ['Safety Details', 'values'],
    vacuum: ['Vacuum', 'Value'],
    power: ['Power Consumption', 'kWh Per Pallet'],
    t_w: ['Tear & Wear', 'Value'],
    collisions: ['objects_colliding', 'impact_depth', 'category'],
    movementData: [
      'No. of boxes attached',
      'Payload (Gripper Not Included)',
      'max_speed_reached',
      'number_of_moves',
    ],
    movementBoxes: [
      'Movement bounding box',
      'X-min ⇀ X-max',
      'Y-min ⇀ Y-max',
      'Z-min ⇀ Z-max',
    ],
  };

  tableData: {
    hw: ITableData[];
    sw: ITableData[];
    installation: ITableData[];
    pally: ITableData[];
    status: ITableData[];
    productivity: ITableData[];
    safety: ITableData[];
    power: ITableData[];
    t_w: ITableData[];
    collisions: ITableData[];
    movementData: ITableData<any>[];
    movementBoxes: ITableData<any>[];
    safety_settings: ITableData[];
  } = {
    hw: [],
    sw: [],
    installation: [],
    pally: [],
    status: [],
    productivity: [],
    safety: [],
    power: [],
    t_w: [],
    collisions: [],
    movementData: [],
    movementBoxes: [],
    safety_settings: [],
  };

  commentsSortOptions = [
    {
      label: 'Last edited',
      value: 'updated_at',
      selected: true,
    },
    {
      label: 'Name',
      value: 'name',
      selected: false,
    },
    {
      label: 'Creation Date',
      value: 'created_at',
      selected: false,
    },
  ];

  keySubstitutions = {
    robot_os: 'Robot OS',
    pally_version: 'Pally URCap version',
    smart_grip: 'Max grip',
    lift_kit: 'Lifting column',
  };

  round = Math.round;

  simviz_loadinfo: ISimvizLoadInfo;

  constructor(
    public route: ActivatedRoute,
    private router: Router,
    private simApiService: SimulationApiService,
    private infoApi: InfoApiService,
    private errorHandler: ErrorHandlerService,
    private exportImportService: ExportImportService,
    private dialogService: DialogService,
    private clipboard: Clipboard,
    private notify: NotificationService,
    private simulationDataService: SimulationDetailsDataService,
    public stateService: StateService,
    private dialog: MatDialog,
    private gas: GoogleAnalyticsService,
    public appLayout: AppLayoutService,
    private location: Location,
    private localStorageService: LocalStorageService,
    public publicApi: PublicApiService
  ) {}

  ngOnInit(): void {
    this.isOpen = this.route.snapshot.queryParams?.o === '1';

    this.contentfulSimFooterElements$ = this.infoApi
      .getSimulationReportFooterElements()
      .pipe(take(1), toRequestState());

    this.publicSimulationShare$ = this.simApiService
      .getPublicSimulationShared(this.route.snapshot.params.id)
      .pipe(
        map((data) => data.data.simulation_share),
        tap((data) => {
          this.simSharedValidTo = data[0]?.valid_to || null;
        })
      );

    this.stateService.isUserLogged$.subscribe((isUserLogged) => {
      this.setSimulationdetailDataFetch(!isUserLogged && !this.isOpen);
      if (!isUserLogged || this.isOpen) {
        this.isPublic$ = of(true);
        this.simulationDataService.isSimPublicService.next(true);
      } else {
        this.isPublic$ = this.publicSimulationShare$.pipe(
          map((simulation_share) => {
            let isPublic = false;
            if (simulation_share.length > 0) {
              isPublic =
                new Date(simulation_share[0].valid_to) < new Date(Date.now())
                  ? false
                  : true;
            }
            this.simulationDataService.isSimPublicService.next(isPublic);
            if (isPublic && !window.location.href.includes('public='))
              UrlUtils.addQueryParamsNoReload('public=true');
            return isPublic;
          })
        );
      }

      this.simulationDetails$ = this.simulationDetailsData$.pipe(
        switchMap((result) => {
          /**
           * If logged in and trying to get another org's Sim (with no access), retry in public mode.
           * PALLY-2853
           */
          if (
            !result &&
            this.route.snapshot.queryParams?.public &&
            isUserLogged
          ) {
            this.setSimulationdetailDataFetch(
              (this.isThirdPartySimulation = true)
            );
            return this.simulationDetailsData$;
          }
          return of(result);
        }),
        switchMap((simulation_details) => {
          const shared$ = this.publicSimulationShare$.pipe(
            map((simulation_share) => {
              let isPublic = false;
              if (simulation_share.length > 0) {
                isPublic =
                  new Date(simulation_share[0].valid_to) < new Date(Date.now())
                    ? false
                    : true;
              }
              return isPublic;
            })
          );
          return combineLatest([
            this.isOpen ? of(true) : shared$,
            of(simulation_details),
            this.publicSimulationShare$,
          ]);
        }),
        map(([shared, simulation_details, share]) => {
          // If public link, check for timeout
          if (!isUserLogged) {
            if (
              !shared &&
              !this.route.snapshot.queryParams.public &&
              !this.isOpen
            ) {
              throw new Error('The shared link has expired.');
            }
          }
          return [simulation_details, share];
        }),
        catchError((error) => {
          if (
            error.message === 'The shared link has expired.' ||
            error.message === 'This simulation may have expired.' ||
            error.message === 'Simulation not publicly shared'
          ) {
            this.router.navigate([pagesPATH.SHARED_LINK_EXPIRED]);
          }
          if (error.message.includes('getPublicSimulationDetails'))
            this.errorHandler.handleError(error);
          return of(error);
        }),
        tap(([simDetails, _]: [ISimulationDetails, any]) => {
          if (simDetails.simulation_state === SimulationStatus.QUEUED) {
            this.isQueued = true;
          } else {
            this.isQueued = false;
          }
        }),
        switchMap(([simulationDetails, share]) => {
          if (this.isOpen && simulationDetails.valid_to) {
            this.simSharedValidTo = simulationDetails.valid_to;
          }
          if (simulationDetails.artifactURLs) {
            const reportKey =
              Object.keys(simulationDetails.artifactURLs).find(
                (k) => ~k.indexOf('_new_report.pdf')
              ) || 'report';

            this.artifactsURL = {
              bag: simulationDetails.artifactURLs.bag,
              urdf: simulationDetails.artifactURLs.urdf,
              report: simulationDetails.artifactURLs[reportKey],
              sim_urp: simulationDetails.artifactURLs.sim_urp,
              sim_installation: simulationDetails.artifactURLs.sim_installation,
              robot_urp: simulationDetails.artifactURLs.robot_urp,
              robot_installation:
                simulationDetails.artifactURLs.robot_installation,
            };
          }

          // TODO: Look into a better way to handle this? Good enough for now.
          // If the simulation is shared, get the artifact URLs from the share.
          // These are enforced to have the same expiration date.
          if (share.length > 0 && share[0]?.artifact_urls) {
            if (this.artifactsURL) {
              this.artifactsURL.bag = share[0].artifact_urls.bag;
              this.artifactsURL.urdf = share[0].artifact_urls.urdf;
            } else {
              this.artifactsURL = {
                bag: share[0].artifact_urls.bag,
                urdf: share[0].artifact_urls.urdf,
              };
            }
          }

          if (simulationDetails.organization?.assets?.length) {
            this.publicCustomerOrganizationAsset =
              simulationDetails.organization.assets[0].url;
          } else if (
            simulationDetails.default_sim_config?.organization?.assets?.length
          ) {
            this.publicCustomerOrganizationAsset =
              simulationDetails.default_sim_config.organization.assets.reverse()[0].url;
          }
          const publicSalesOrganizationAsset =
            simulationDetails.organization?.organization_relations?.[0]
              ?.organization_a.assets?.[0]?.url;
          const publicOpenSimSalesOrganizationAsset =
            simulationDetails.default_sim_config?.organization
              ?.organization_relations?.[0]?.organization_a.assets?.[0]?.url;
          if (publicSalesOrganizationAsset) {
            this.publicSalesOrganizationAsset = publicSalesOrganizationAsset;
          } else if (publicOpenSimSalesOrganizationAsset) {
            this.publicSalesOrganizationAsset =
              publicOpenSimSalesOrganizationAsset;
          }
          if (simulationDetails.metadata?.unitSystem === 'imperial') {
            this.useImperial = true;
          } else if (
            this.localStorageService.getData(
              LocalStorageKey.PREFERRED_UNIT_SYSTEM
            ) === 'imperial' &&
            this.isFirstLoad
          ) {
            this.useImperial = true;
          }

          /**
           * @description
           * **TEMPORARY PATCH**: Hard-coded scene logo for the Automate trade show (May 2025).
           * This was explicitly requested to meet the event deadline—do NOT treat as permanent!
           * 👉 REMOVE OR REFACTOR **after** the event.
           *
           * @todo Rewrite this logic to support dynamic logos instead of hard-coding.
           */
          let tradeShowLogoUrl: string;
          if (this.isOpen) {
            tradeShowLogoUrl =
              simulationDetails.default_sim_config?.organization?.id ===
              '116f0659-4e65-4d9d-8a57-0bac0d8e1da2'
                ? '/assets/dummy/tmpTradeShowLogo.png'
                : null;
          }

          this.simviz_loadinfo = {
            id: simulationDetails.id,
            bagURL: this.artifactsURL?.bag,
            urdfURL: this.artifactsURL?.urdf,
            customerOrgStickerSource: this.publicCustomerOrganizationAsset,
            salesOrgStickerSource:
              tradeShowLogoUrl || this.publicSalesOrganizationAsset,
            boxStickerSource: this.publicCustomerOrganizationAsset,
          };
          this.isFirstLoad = false;
          return combineLatest([
            of(simulationDetails),
            this.useImperial
              ? this.simulationDetailsData$.pipe(
                  take(1),
                  map((details) => {
                    this.buildTableData(details);
                    return true;
                  })
                )
              : of(EMPTY),
          ]);
        }),
        switchMap(([simulationDetails, _]) => {
          this.breadcrumbs = [
            {
              label: 'Simulations',
              path: [pagesPATH.SIMULATIONS],
            },
            { label: simulationDetails.name, path: [] },
          ];
          if (simulationDetails.pattern)
            this.project = new Project(
              'simulation-details',
              this.exportImportService.mapToProjectFormat(
                simulationDetails.pattern.data,
                true,
                false
              )
            );
          if (simulationDetails.second_pattern)
            this.second_project = new Project(
              'simulation-details',
              this.exportImportService.mapToProjectFormat(
                simulationDetails.second_pattern.data,
                true,
                false
              )
            );
          this.buildTableData(simulationDetails);
          if (!this.publicCustomerOrganizationAsset) {
            this.publicCustomerOrganizationAsset = simulationDetails
              .organization?.assets
              ? simulationDetails.organization.assets.find(
                  (org) => ~org.url.indexOf('_logo')
                )?.url
              : null;
          }
          this.getAvailableMovementBoxes(simulationDetails.simulation_status);
          return of(simulationDetails);
        }),
        toRequestState()
      );
      this.updateLastActionPerformedTimestamp();
    });
    this.docElement = document.documentElement;
  }

  ngAfterViewInit() {
    // This changes the color of the progress view in the Running State
    this.spinner.changes.subscribe(() => {
      this.spinner.forEach(
        (spin) =>
          (spin._elementRef.nativeElement.querySelector(
            'svg>circle'
          ).style.stroke = 'rgba(247, 247, 251, 0.96)')
      );
    });
  }

  ngOnDestroy() {
    document.removeEventListener('fullscreenchange', this.onFullscreenExit);
    this.destroy$.next(undefined);
    this.destroy$.complete();
  }

  clickLink(url) {
    window.open(url, '_blank');
  }

  private setSimulationdetailDataFetch(viaPublicFetch: boolean): void {
    this.simulationDetailsData$ = this.simApiService.getSimulationDetails(
      this.route.snapshot.params.id,
      viaPublicFetch,
      this.isOpen
    );
  }

  private buildTableData(simulationDetails: ISimulationDetails): void {
    if (simulationDetails?.hw) {
      Object.keys(simulationDetails.hw).forEach((hardware) => {
        simulationDetails.hw[hardware] = getConvertedValue(
          `${simulationDetails.hw[hardware]}`,
          this.useImperial ? 'imperial' : 'metric'
        );
      });
    }
    if (simulationDetails.installation) {
      Object.keys(simulationDetails.installation).forEach((setup) => {
        simulationDetails.installation[setup] = getConvertedValue(
          `${simulationDetails.installation[setup]}`,
          this.useImperial ? 'imperial' : 'metric'
        );
      });
    }
    if (simulationDetails.pally_settings) {
      Object.keys(simulationDetails.pally_settings).forEach((setting) => {
        simulationDetails.pally_settings[setting] = getConvertedValue(
          `${simulationDetails.pally_settings[setting]}`,
          this.useImperial ? 'imperial' : 'metric'
        );
      });
    }
    simulationDetails.movementData?.forEach((movementData) => {
      if (movementData.data) {
        Object.keys(movementData.data).forEach((key) => {
          movementData.data[key] = getConvertedValue(
            `${movementData.data[key]}`,
            this.useImperial ? 'imperial' : 'metric'
          );
          const newKey = this.keySubstitutions[key];
          if (newKey) {
            movementData.data[newKey] = movementData.data[key];
            delete movementData.data[key];
          }
        });
      }
    });
    if (simulationDetails.movementBoxes) {
      simulationDetails.movementBoxes?.forEach((movementBox) => {
        const convertThis = (value) => {
          return getConvertedValue(
            `${value}`,
            this.useImperial ? 'imperial' : 'metric'
          );
        };
        Object.keys(movementBox.data).forEach((workspace) => {
          if (!workspace.startsWith('Movement')) {
            const values = movementBox.data[workspace].split('⇀');
            movementBox.data[workspace] = `${convertThis(
              values[0]?.trim()
            )} ⇀ ${convertThis(values[1]?.trim())}`;
          }
        });
      });
    }
    this.tableData.collisions = this.getCollisionSummary(
      simulationDetails.simulation_status?.collisions
    );
    this.tableData.status = simulationDetails.status;
    this.tableData.productivity = simulationDetails.pattern?.productivity;
    this.tableData.safety = simulationDetails.safety;
    this.tableData.power = simulationDetails.power;
    const vacuumPallet = simulationDetails.vacuum?.find(
      (v) => v.data['Vacuum'] === 'Vacuum per pallet'
    ).data['Value'];
    const vacuumHour = simulationDetails.vacuum?.find(
      (v) => v.data['Vacuum'] === 'Vacuum per hour'
    ).data['Value'];

    this.tableData.hw = this.generateHwTableData(simulationDetails.hw);
    this.tableData.power.find(
      (p) => p.data['Power Consumption'] === 'Vacuum load'
    ).infoPopup = {
      id: 'vacuum_load',
      dataSource: this.infoPopupDataSource,
      substitutions: {
        vacuum_per_pallet: vacuumPallet,
        vacuum_per_hour: vacuumHour,
      },
    };
    this.tableData.t_w = simulationDetails.t_w;
    this.tableData.movementData = simulationDetails.movementData;
    this.tableData.movementBoxes = simulationDetails.movementBoxes;
    this.tableData.sw = this.dataToDisplayedColumns('sw', simulationDetails.sw);
    this.tableData.installation = this.generateInstallationTableData(
      simulationDetails.installation
    );
    if (
      'optimove_max_speed_percentage' in simulationDetails.pally_settings ||
      'optimove_max_acceleration_percentage' in simulationDetails.pally_settings
    ) {
      // Delete old speed values.
      delete simulationDetails.pally_settings['max_robot_speed'];
      delete simulationDetails.pally_settings['max_robot_acceleration'];

      if ('optimove_max_speed_percentage' in simulationDetails.pally_settings) {
        const optimove_speed = simulationDetails.pally_settings[
          'optimove_max_speed_percentage'
        ] as number;
        simulationDetails.pally_settings['optimove_max_speed_percentage'] = `${
          optimove_speed * 100
        } [%]`;
      }
      if (
        'optimove_max_acceleration_percentage' in
        simulationDetails.pally_settings
      ) {
        const optimove_acceleration = simulationDetails.pally_settings[
          'optimove_max_acceleration_percentage'
        ] as number;
        simulationDetails.pally_settings[
          'optimove_max_acceleration_percentage'
        ] = `${optimove_acceleration * 100} [%]`;
      }
    }
    this.tableData.pally = this.dataToDisplayedColumns(
      'pally',
      simulationDetails.pally_settings
    );
    this.tableData.safety_settings = this.generateSafetySettingsTableData(
      simulationDetails.safety
    );
  }
  dataToDisplayedColumns(tableName: tableName, data: object): ITableData[] {
    const tableData: ITableData[] = [];
    const col1Name = this.displayedColumns[tableName][0];
    const col2Name = this.displayedColumns[tableName][1];
    if (data) {
      Object.entries(data).forEach(([key, value]) => {
        if (key === '__typename') return;
        // Format the value.
        let keyAsValue =
          key.charAt(0).toUpperCase() + key.slice(1).replace(/_/g, ' ');
        if (this.keySubstitutions[key]) keyAsValue = this.keySubstitutions[key];
        // Add data to new columns
        tableData.push({
          data: {
            [col1Name]: keyAsValue,
            [col2Name]: value,
          },
        });
      });
    }
    return tableData;
  }

  generateHwTableData(hw: ISimulationDetails['hw']): ITableData[] {
    if (!hw) return null;
    const tableData = {
      base_type: hw.base,
      // Changes column title based on the presence of a secondary conveyor.
      [hw.primary_conveyor_type && !hw.secondary_conveyor_type
        ? 'conveyor_type'
        : 'primary_conveyor_type']: hw.primary_conveyor_type,
      secondary_conveyor_type: hw.secondary_conveyor_type,
      robot_type: hw.robot,
      lifting_column_type: hw.lift_kit,
      lift_stroke: hw.lift_stroke,
      gripper_type: hw.gripper,
      gripper_bracket: hw.gripper_bracket,
      mounting_bracket: hw.mounting_bracket,
    };

    if (!hw.primary_conveyor_type) {
      delete tableData.primary_conveyor_type;
    }
    if (!hw.secondary_conveyor_type) {
      delete tableData.secondary_conveyor_type;
    }
    return this.dataToDisplayedColumns('hw', tableData);
  }

  generateInstallationTableData(
    installation: ISimulationDetails['installation']
  ): ITableData[] {
    if (!installation) return null;
    const tableData = {
      lifting_column_duty_cycle_avg: installation.lifting_column_duty_cycle_avg,
      lifting_column_duty_cycle_max: installation.lifting_column_duty_cycle_max,
      [installation.conveyor_height && !installation.secondary_conveyor_height
        ? 'conveyor_transportation_height'
        : 'primary_conveyor_transportation_height']:
        installation.conveyor_height,
      [installation.robot_conveyor_distance &&
      !installation.robot_secondary_conveyor_distance
        ? 'robot_conveyor_distance'
        : 'robot_primary_conveyor_distance']:
        installation.robot_conveyor_distance,
      secondary_conveyor_transportation_height:
        installation.secondary_conveyor_height,
      robot_secondary_conveyor_distance:
        installation.robot_secondary_conveyor_distance,
      robot_pallet_edge_distance: installation.robot_pallet_edge_distance,
      robot_mounting_height: installation.robot_mounting_height,
      total_TCP_offset: installation.total_TCP_offset,
      used_floor_space_width: installation.used_floor_space_width,
      used_floor_space_length: installation.used_floor_space_length,
      used_floor_space_area: installation.used_floor_space_area,
    };

    const tableDataConverted = this.dataToDisplayedColumns(
      'installation',
      tableData
    );
    tableDataConverted.find(
      (p) => p.data['installation setup'] === 'Robot pallet edge distance'
    ).infoPopup = {
      id: 'robot_pallet_edge_distance',
      dataSource: this.infoPopupDataSource,
    };
    return tableDataConverted;
  }

  private generateSafetySettingsTableData(
    safety: ISimulationDetails['safety']
  ): { data: { 'Safety Details': string; values: string | number } }[] {
    if (!safety || !Array.isArray(safety) || safety.length === 0) return null;
    const result: {
      data: { 'Safety Details': string; values: string | number };
    }[] = [];
    safety.forEach((row) => {
      if (!row || !row.data) return;
      const safetyKey = row.data.Safety;
      if (!safetyKey) return;
      if (safetyKey === 'Safety Level' && row.data.Level) {
        result.push({
          data: {
            'Safety Details': 'Safety Preset',
            values: row.data.Level,
          },
        });
      }
      if (safetyKey === 'Pally Safety Restrictions') {
        result.push({
          data: {
            'Safety Details': 'Max Speed Safety Preset',
            values: !row.data['Max Speed']
              ? 'N/A'
              : getConvertedValue(
                  `${row.data['Max Speed']} [mm/s]`,
                  this.useImperial ? 'imperial' : 'metric'
                ),
          },
        });
      }
      if (safetyKey === 'Simulation Results') {
        result.push({
          data: {
            'Safety Details': 'Max Speed Simulation Achieved',
            values:
              !row.data['Max Speed'] || isNaN(row.data['Max Speed'])
                ? 'N/A'
                : getConvertedValue(
                    `${row.data['Max Speed'].toFixed(2)} [mm/s]`,
                    this.useImperial ? 'imperial' : 'metric'
                  ),
          },
        });
      }
    });
    return result;
  }

  async generateSimulationReportPDF(handler: (string) => void) {
    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'A4',
    });

    const simulationReport = this.simulationReport.nativeElement;
    simulationReport.style.display = 'initial';
    simulationReport.offsetHeight;
    await pdfUtils.addElementToPDF(doc, simulationReport, 0, 0);
    simulationReport.style.display = '';

    const bloburl = doc.output('bloburl');
    handler(bloburl);
  }

  public downloadSimulationReport(name: string): void {
    if (this.isOpen) {
      this.sendGasEvtId(
        'Simulation Details - Fast Track - MyRobot.cloud - Download Simulation Report - Click'
      );
    }
    const title = `Simulation report-${name}`;
    const simulationReport$ = new Observable<string>((subscriber) => {
      this.generateSimulationReportPDF((url) => {
        subscriber.next(url);
        subscriber.complete();
      });
    });
    this.openPdfPreviewDialog(simulationReport$, title);
  }

  public downloadPalletReport(patternData: IPallyFileType): void {
    this.showReport = true;
    this.patternReportData = patternData;
    if (this.isOpen) {
      this.sendGasEvtId(
        'Simulation Details - Fast Track - MyRobot.cloud - Download Pallet Report - Click'
      );
    }
    // Wait for the report component to render
    from(pdfUtils.waitForElement('.pdf-report', document))
      .pipe(
        switchMap(() => this.palletReport.ready$),
        take(1)
      )
      .subscribe(() => {
        this.openPdfPreviewDialog(
          this.generatePalletReportPDF(),
          'Pallet report'
        );
      });
  }

  public downloadAsSTL(filename?: string): void {
    if (this.isOpen) {
      this.sendGasEvtId(
        'Simulation Details - Fast Track - MyRobot.cloud - Download STL - Click'
      );
    }
    if (this.simviz?.simulationView) {
      this.simviz.simulationView.downloadRobotmodel(filename);
    }
  }

  hasURPAndInstallationUrls(artifactsURL): boolean {
    return Boolean(
      (artifactsURL.sim_urp && artifactsURL.sim_installation) ||
        (artifactsURL.robot_urp && artifactsURL.robot_installation)
    ).valueOf();
  }

  downloadURPAndInstallation(simName: string, artifactURLs: IArtifactsUrl) {
    if (!this.hasURPAndInstallationUrls(artifactURLs)) {
      console.error('missing files to download');
      return;
    }
    if (this.isOpen) {
      this.sendGasEvtId(
        'Simulation Details - Fast Track - MyRobot.cloud - Download URP - Click'
      );
    }
    const getObsFrom = (url: string): Observable<Response> => {
      return from(fetch(url)).pipe(
        catchError((error: Error) => {
          console.error(error);
          return of(undefined);
        })
      );
    };

    const list: Observable<Response>[] = [];
    if (artifactURLs.sim_urp) {
      list.push(getObsFrom(artifactURLs.sim_urp));
    }
    if (artifactURLs.sim_installation) {
      list.push(getObsFrom(artifactURLs.sim_installation));
    }
    if (artifactURLs.robot_urp) {
      list.push(getObsFrom(artifactURLs.robot_urp));
    }
    if (artifactURLs.robot_installation) {
      list.push(getObsFrom(artifactURLs.robot_installation));
    }
    combineLatest(list)
      .pipe(
        take(1),
        takeUntil(this.destroy$),
        switchMap((list: Response[]) =>
          combineLatest(list.map((r: Response) => from(r.blob())))
        )
      )
      .subscribe({
        next: (blobs) => {
          const zip = new JSZip();

          const sim_urp = blobs.length > 0 ? blobs[0] : undefined;
          const sim_installation = blobs.length > 1 ? blobs[1] : undefined;
          const robot_urp = blobs.length > 2 ? blobs[2] : undefined;
          const robot_installation = blobs.length > 3 ? blobs[3] : undefined;

          if (sim_urp) {
            zip.file(simName + ' - sim.urp', sim_urp);
          }
          if (sim_installation) {
            zip.file(simName + ' - sim.installation', sim_installation);
          }
          if (robot_urp) {
            zip.file(simName + ' - robot.urp', robot_urp);
          }
          if (robot_installation) {
            zip.file(simName + ' - robot.installation', robot_installation);
          }
          zip.generateAsync({ type: 'blob' }).then(function (content) {
            saveAs(content, simName + ' - urp-installation.zip');
          });
        },
        error: (error: Error) => console.error(error),
      });
  }

  private generatePalletReportPDF(): Observable<string> {
    const doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: 'A4',
    });
    return from(
      pdfUtils.addElementToPDF(doc, this.palletReportRef.nativeElement, 0, 0)
    ).pipe(
      map(() => {
        this.showReport = false;
        return doc.output('bloburl').toString();
      })
    );
  }

  private openPdfPreviewDialog(
    pdfUrl: Observable<string> | string,
    title: string
  ): void {
    const data = {
      url: pdfUrl,
      title: title.replace(/\./g, ' '),
    };

    this.dialogService.showCustomDialog(
      PdfPreviewComponent,
      DialogSize.LARGE,
      null,
      data,
      true
    );
  }

  public getBgStatusClass(status: SimulationStatus): string {
    switch (status) {
      case SimulationStatus.QUEUED:
      case SimulationStatus.INITIALIZING:
      case SimulationStatus.RUNNING:
      case SimulationStatus.STARTING_ROBOT:
      case SimulationStatus.SETTING_UP:
      case SimulationStatus.PALLETIZING:
        return 'loading-sim';
      case SimulationStatus.CANCELED:
        return 'canceled-sim';
      case SimulationStatus.CREATED:
        return 'created-sim';
      case SimulationStatus.ERROR:
        return 'error-sim';
      case SimulationStatus.FINISHED:
        return 'default-sim';
      case SimulationStatus.SUCCESSFUL:
        return 'success-sim';
      default:
        return 'default-sim';
    }
  }

  public getAchivedMaxSpeed(maxSpeed: number): number {
    return this.round(
      this.unitSystemConversion(
        maxSpeed,
        'mm/s',
        this.useImperial ? 'imperial' : null
      ).value || 0
    );
  }

  public setSimulationPublic(setPublic: boolean): void {
    const insertShare = this.route.params.pipe(
      map((params) => params.id),
      switchMap((sim_id: string) =>
        combineLatest([
          of(sim_id),
          this.artifactsURL.bag &&
          this.artifactsURL.urdf &&
          this.artifactsURL.report
            ? of(this.artifactsURL)
            : this.getSimulationFilesById(sim_id),
        ])
      ),
      switchMap(([sim_id, files]) => {
        if (!files) throw new Error('Failed to fetch simulation data!');
        const reportKey = Object.keys(files).find(
          (k) => ~k.indexOf('_new_report.pdf')
        );
        return this.simApiService.insertPublicSimulationShare(
          sim_id,
          reportKey || files.report
            ? {
                bag: files.bag || files['simulation_recording.bag'],
                urdf: files.urdf || files['model.urdf'],
                report: files.report || files[reportKey],
              }
            : {
                bag: files['simulation_recording.bag'],
                urdf: files['model.urdf'],
              },
          null
        );
      }),
      catchError((err) => {
        this.notify.showError(err);
        return EMPTY;
      }),
      take(1)
    );

    const deleteShare = this.route.params.pipe(
      take(1),
      map((params) => params.id),
      switchMap((sim_id: string) =>
        this.simApiService.deletePublicSimulationShare(sim_id)
      ),
      take(1)
    );

    if (setPublic) {
      insertShare.pipe(take(1)).subscribe(() => {
        UrlUtils.addQueryParamsNoReload('public=true');
        this.copyShareLink();
      });
    } else {
      deleteShare.pipe(take(1)).subscribe({
        next: () => {
          UrlUtils.removeQueryParamsNoReload();
        },
        error: (err) => this.errorHandler.handleError(err),
      });
    }
  }

  public updatePublicSimulationExpiration(expiration: number): void {
    this.route.params
      .pipe(
        map((params) => params.id),
        switchMap((sim_id: string) => {
          return this.simApiService.updatePublicSimulationShare(
            sim_id,
            expiration
          );
        })
      )
      .subscribe(() =>
        this.notify.showSuccess(
          'Registered! Give us a minute to update the links 👍'
        )
      );
  }

  private getSimulationFilesById(
    simulationId: string,
    isPublic?: boolean,
    expiration?: number
  ): Observable<any> {
    return this.simApiService.fetchSimulationFilesByID(
      simulationId,
      isPublic,
      expiration
    );
  }

  copyShareLink() {
    if (this.isOpen) {
      this.sendGasEvtId(
        'Simulation Details - Fast Track - MyRobot.cloud - Copy link - Click'
      );
    }
    this.isPublic$.pipe(take(1)).subscribe((_) => {
      this.clipboard.copy(window.location.href);
      this.notify.showSuccess('Link copied to clipboard!');
    });
  }

  public targetMaxSpeedValue(simulationDetails: ISimulationDetails): {
    value: number;
    unit: string;
  } {
    const safetylevel = simulationDetails.safety[0].data.Level;
    let maxSpeed;
    switch (safetylevel) {
      case 'MostRestricted':
        maxSpeed = 250;
        break;
      case 'Restricted':
        maxSpeed = 750;
        break;
      case 'LessRestricted':
        maxSpeed = 1500;
        break;
      case 'LeastRestricted':
        maxSpeed = 5000;
        break;
      case 'CustomMax250':
        maxSpeed = 250;
        break;
      case 'CustomMax500':
        maxSpeed = 500;
        break;
      case 'CustomMax750':
        maxSpeed = 750;
        break;
      case 'CustomMax1000':
        maxSpeed = 1000;
        break;
      case 'CustomMax1250':
        maxSpeed = 1250;
        break;
      case 'CustomMax1500':
        maxSpeed = 1500;
        break;
      case 'CustomMax1750':
        maxSpeed = 1750;
        break;
      case 'CustomMax2000':
        maxSpeed = 2000;
        break;
      case 'CustomMax2500':
        maxSpeed = 2500;
        break;
      default:
        maxSpeed = 0;
        break;
    }
    const unit = this.useImperial ? 'imperial' : 'metric';
    return this.unitSystemConversion(maxSpeed, 'mm/s', unit);
  }

  getProductDimensions(
    simulationDetails: ISimulationDetails,
    second: boolean = false
  ): Map<string, any> {
    const pattern = second
      ? simulationDetails.second_pattern
      : simulationDetails.pattern;

    const dimensions = pattern.data.productDimensions;
    const unit = this.useImperial ? 'imperial' : 'metric';
    const displayedData = {
      name: pattern.product.name || 'Missing name',
      length: getConvertedValue(dimensions.length + ' mm', unit),
      height: getConvertedValue(dimensions.height + ' mm', unit),
      width: getConvertedValue(dimensions.width + ' mm', unit),
      weight: getConvertedValue(
        this.useImperial
          ? dimensions.weight * 0.001 + ' kg'
          : dimensions.weight + ' g',
        unit
      ),
    };

    return new Map(Object.entries(displayedData));
  }

  getPalletDimensions(
    simulationDetails: ISimulationDetails,
    second: boolean = false
  ): Map<string, any> {
    const pattern = second
      ? simulationDetails.second_pattern
      : simulationDetails.pattern;
    const dimensions = pattern.data.dimensions;

    const unit = this.useImperial ? 'imperial' : 'metric';
    const displayedData = {
      name: this.getPalletNameFromDimensions(
        dimensions.length,
        dimensions.width
      ),
      length: getConvertedValue(dimensions.length + ' mm', unit),
      height: getConvertedValue(dimensions.palletHeight + ' mm', unit),
      width: getConvertedValue(dimensions.width + ' mm', unit),
    };

    return new Map(Object.entries(displayedData));
  }

  getPatternData(
    simulationDetails: ISimulationDetails,
    second: boolean = false
  ): Map<string, any> {
    const pattern = second
      ? simulationDetails.second_pattern
      : simulationDetails.pattern;

    const patternData = pattern.data;
    const palletDimensions = patternData.dimensions;
    const boxDimensions = patternData.productDimensions;

    const boxCount = this.getNumBoxes(patternData);
    const palletArea = palletDimensions.width * palletDimensions.length;
    const boxArea = boxDimensions.width * boxDimensions.length;
    const layer1BoxCount = this.getNumBoxes(patternData, 1);

    const palletAreaEfficiency = (boxArea * layer1BoxCount) / palletArea;
    const palletCubeEfficiency =
      (boxArea * boxCount) / (palletArea * patternData.layers.length);

    let palletLoadHeight = calcTotalPalletLoadHeightFromPallyFile(patternData);

    const displayedData = {
      Name: patternData.name || 'N/A',
      'Box count': boxCount,
      'Pallet height': getConvertedValue(
        palletLoadHeight + palletDimensions.palletHeight + ' mm',
        this.useImperial ? 'imperial' : 'metric'
      ),
      'Pallet load height': getConvertedValue(
        palletLoadHeight + ' mm',
        this.useImperial ? 'imperial' : 'metric'
      ),
      'Total weight': getConvertedValue(
        (boxDimensions.weight * boxCount) / 1000 + ' kg',
        this.useImperial ? 'imperial' : 'metric'
      ),
      Layers: patternData.layers.length,
      'Pallet area efficiency': (palletAreaEfficiency * 100).toFixed(2) + ' %',
      'Pallet cube efficiency': (palletCubeEfficiency * 100).toFixed(2) + ' %',
    };

    return new Map(Object.entries(displayedData));
  }

  getPalletNameFromDimensions(length: number, width: number): string {
    const matches = ListOfAllPallets.filter(
      (pallet) => pallet.length === length && pallet.width === width
    );
    const pallet = matches[0];

    if (!pallet) {
      return '--';
    }

    return pallet.name;
  }

  getNumBoxes(data: IPallyFileType, maxNumLayers = -1): number {
    let countInLayer = {};
    const numLayers =
      maxNumLayers < 0
        ? data.layers.length
        : Math.min(maxNumLayers, data.layers.length);
    data.layerTypes.forEach((layerLayout) => {
      const boxCount = layerLayout.pattern?.length
        ? layerLayout.pattern.length
        : 0;
      countInLayer[layerLayout.name] = boxCount;
    });

    let sum = 0;
    for (let i = 0; i < numLayers; i++) {
      const layerType = data.layers[i];
      sum += countInLayer[layerType] ? countInLayer[layerType] : 0;
    }
    return sum;
  }

  castToNumber(val: any): number {
    if (typeof val === 'string') {
      return parseFloat(val);
    } else {
      return val;
    }
  }

  openInfoPopup(
    id: string,
    values?: {
      simulationDetails?: ISimulationDetails;
      prodDim?: Map<string, number>;
      pallDim?: Map<string, number>;
      pattern?: Map<string, number>;
      safety_regulations?: number;
      avg_minutes_per_pallet?: number;
      wear_and_tear?: string;
    }
  ) {
    const substitutions: any = {};

    // Available for: status (all), cpm, max speed, avg minutes pallet, max products, pallet
    if (values?.simulationDetails) {
      const simulationDetails = values.simulationDetails;
      substitutions.progress =
        simulationDetails.simulation_status?.progress || '0';
      substitutions.error = simulationDetails.error_details;
      substitutions.pall_height = getConvertedValue(
        (simulationDetails.pattern?.data?.dimensions?.height || '~') + ' mm',
        this.useImperial ? 'imperial' : 'metric'
      );
    }

    // Available for: safety regulations
    if (values?.safety_regulations) {
      substitutions.safety_regulations = values.safety_regulations;
    }

    // Available for: average minutes per pallet
    if (values?.avg_minutes_per_pallet) {
      substitutions.avg_minutes_per_pallet = values.avg_minutes_per_pallet;
    }

    // Available for: cases per minute
    if (id === 'cpm') {
      substitutions.cpm =
        values?.simulationDetails?.status[0]?.data['CPM Achieved'] || '0';
    }

    // Available for: product
    if (values?.prodDim) {
      const prodDim = values.prodDim;
      substitutions.prod_length = getConvertedValue(
        prodDim.get('length') + ' mm',
        this.useImperial ? 'imperial' : 'metric'
      );
      substitutions.prod_height = getConvertedValue(
        prodDim.get('height') + ' mm',
        this.useImperial ? 'imperial' : 'metric'
      );
      substitutions.prod_width = getConvertedValue(
        prodDim.get('width') + ' mm',
        this.useImperial ? 'imperial' : 'metric'
      );
      substitutions.prod_weight = prodDim.get('weight');
    }

    // Available for: pallet
    if (values?.pallDim) {
      const pallDim = values.pallDim;
      substitutions.pall_length = getConvertedValue(
        pallDim.get('length') + ' mm',
        this.useImperial ? 'imperial' : 'metric'
      );
      substitutions.pall_width = getConvertedValue(
        pallDim.get('width') + ' mm',
        this.useImperial ? 'imperial' : 'metric'
      );
      substitutions.pall_pallet_height = getConvertedValue(
        pallDim.get('height') + ' mm',
        this.useImperial ? 'imperial' : 'metric'
      );
    }

    // Available for: pattern
    if (id == 'pattern' && values?.pattern) {
      const pattern = values.pattern;
      substitutions.patt_box_count = pattern.get('Box count');
      substitutions.patt_weight = pattern.get('Weight');
      substitutions.patt_pallet_cube_efficiency = pattern.get(
        'Pallet cube efficiency'
      );
    }

    if (values?.wear_and_tear) {
      substitutions.wear_and_tear = values.wear_and_tear;
    }

    const data = {
      id: id,
      dataSource: this.infoPopupDataSource,
      substitutions: substitutions,
    };

    this.dialogService.showCustomDialog(
      InfoPopupComponent,
      DialogSize.MEDIUM,
      null,
      data,
      true
    );
  }

  renameClick(id: string) {
    this.simulationDetailsData$
      .pipe(
        take(1),
        switchMap((simulationDetails) => {
          const dialogRef = this.dialog.open(RenameSimulationComponent, {
            data: {
              simulation_name: simulationDetails.name,
            },
          });
          return dialogRef.afterClosed();
        }),
        filter(Boolean),
        switchMap((result) => {
          // User asked to rename simulation, report becomes temporarily unavailable
          this.simReportDisabled = true;
          return this.simApiService.renameSimulation(id, result);
        }),
        switchMap(() => {
          return this.simApiService.regenerateReportFromSimReportData(id);
        })
      )
      .subscribe({
        next: () => {
          // Report regenerated and available for preview
          this.simReportDisabled = false;
        },
        error: (err) => console.error(err),
      });
  }

  tabGroupClick(e: MatTabChangeEvent) {
    switch (e.index) {
      case 0:
        this.sendGasEvtId('Simulation Details - MyRobot.cloud	Summary - Click');
        break;
      case 1:
        this.sendGasEvtId('Simulation Details - MyRobot.cloud	Hardware - Click');
        break;
      case 2:
        this.sendGasEvtId(
          'Simulation Details - MyRobot.cloud	Installation Setup - Click'
        );
        break;
      case 3:
        this.sendGasEvtId('Simulation Details - MyRobot.cloud	Software - Click');
        break;
    }
  }

  public toggleUnitSystem(): void {
    this.useImperial = !this.useImperial;
    this.simulationDetailsData$
      .pipe(take(1))
      .subscribe((simulationDetails) => this.buildTableData(simulationDetails));
  }

  /**
   * Opens the Quote-Request dialog.
   * @param simulationId
   */
  public openRequestQuoteDialog(simulationId: string): void {
    if (this.isOpen) {
      this.dialogService
        .showCustomDialog(
          QuoteFormDialogComponent,
          DialogSize.MEDIUM,
          null,
          {
            lastActionCooldown: this.lastActionTimestamp,
            simulationId: simulationId,
          },
          true
        )
        .afterClosed()
        .subscribe(() => {
          this.updateLastActionPerformedTimestamp();
          this.sendGasEvtId(
            'Simulation Details - Fast Track - MyRobot.cloud - Request Quote - Click'
          );
        });
    }
  }

  public updateLastActionPerformedTimestamp(): void {
    this.lastActionTimestamp = Date.now();
  }

  /**
   * @description Toggles the simulation player mode.
   * @param {PlayerMode} event
   * @todo Add support for fullscreen exit on ESC key press.
   * @todo Add support for fullscreen exit on click outside of the player.
   * @todo Add support for fullscreen exit on click on the fullscreen button.
   */
  public togglePlayerMode(event: PlayerMode): void {
    if (event === PlayerMode.FULLSCREEN) {
      this.docElement.requestFullscreen();
      document.body.style.overflowY = 'hidden';
      document.addEventListener(
        'fullscreenchange',
        this.onFullscreenExit,
        false
      );
      window.scroll({ top: 0 });
    } else if (document.fullscreenElement) {
      document.body.style.removeProperty('overflow-y');
      document.exitFullscreen();
      document.removeEventListener('fullscreenchange', this.onFullscreenExit);
    }
    this.simulationPlayerMode = event;
  }

  private onFullscreenExit(): void {
    this.simulationPlayerMode = PlayerMode.DEFAULT;
    document.removeEventListener('fullscreenchange', this.onFullscreenExit);
  }

  /**
   * @description Generates the collision summary table data.
   * @param {ISimulationCollision[]} collisions
   * @returns {ITableData[]}
   */
  private getCollisionSummary(
    collisions: ISimulationCollision[]
  ): ITableData[] {
    let result: ITableData[] = [];
    collisions?.forEach((collision) => {
      result.push({
        data: {
          category: collision.category,
          object1: collision.object1,
          object2: collision.object2,
          objects_colliding: `${collision.object1.replace(
            '_',
            ' '
          )} ⇀ ${collision.object2.replace('_', ' ')}`,
          impact_depth: getConvertedValue(
            `${(collision.depth * 1000).toFixed(2)} [mm]`,
            this.useImperial ? 'imperial' : 'metric'
          ),
        },
      });
    });
    return result;
  }

  /**
   * @description Filters out the available movement boxes from the simulation status.
   * @param {ISimulationStatus} simulation_status
   */
  private getAvailableMovementBoxes(simulation_status): void {
    const {
      workspace,
      workspace_first_pallet,
      workspace_second_pallet,
      workspace_with_boxes,
    } = simulation_status;
    this.movementBoxes = {
      workspace,
      workspace_first_pallet,
      workspace_second_pallet,
      workspace_with_boxes,
    };
    const colors = [0x00ff00, 0x0000ff, 0xff0000, 0xffff00];
    Object.keys(this.movementBoxes).forEach((key, index) => {
      if (this.movementBoxes[key] === undefined) delete this.movementBoxes[key];
      else {
        this.movementBoxes[key].id = key;
        this.movementBoxes[key].guiColor = Number(
          colors[index] || Math.floor(Math.random() * 16777215).toString(16)
        );
      }
    });
  }

  /**
   * @description Channels the classe's unit conversion throught the conversion pipe.
   * @param {any} value
   * @param {ImperialUnit | MetricUnit} unit
   * @param {UnitSystemType} outputSystemFormat
   * @param {boolean} fractional
   * @returns { value, unit}
   */
  private unitSystemConversion(
    value: number | string,
    unit: UnitUtils.ImperialUnit | UnitUtils.MetricUnit,
    outputSystemFormat?: UnitUtils.UnitSystemType,
    fractional?: boolean
  ): {
    value: number;
    unit: string;
  } {
    return new UnitSystemPipe(new LocalStorageService()).transform(
      Number(value),
      unit,
      outputSystemFormat,
      fractional
    ) as { value: number; unit: string };
  }

  public goBack(): void {
    this.location.back();
  }

  /**
   * Sends an event's ID to Google Analytics through its service Service.
   * @param id - The ID of the marketing tag.
   */
  private sendGasEvtId(id: MarketingTagID): void {
    this.gas.addEvent(id, null, this.gas.getLastParam());
  }
}

//Service for forwarding data to other components that use app-public-share-card
@Injectable({
  providedIn: 'root',
})
export class SimulationDetailsDataService {
  isSimPublicService: BehaviorSubject<boolean> = new BehaviorSubject(false);
  simValidToService: BehaviorSubject<string> = new BehaviorSubject(undefined);
}
